import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import DataTable from 'components/organisms/data-table'
import tableColumns from './product-fabric-table-columns'

const propTypes = {
  data           : PropTypes.array,
  pagination     : PropTypes.object,
  onFetchData    : PropTypes.func,
  isLoading      : PropTypes.bool,
  hiddenColumns  : PropTypes.arrayOf(PropTypes.string),
  rowButtonProps : PropTypes.object
}

const defaultProps = {
  hiddenColumns : [],
  isLoading     : false
}

/**
 * Table to display Product Material columns
 * @param {Array<Object>} data - array of product materials objects
 * @param {Object} pagination - object of pagination data from endpoint
 * @param {Function} onFetchData - function that will call endpoint for data
 * @param {Boolean} isLoading - whether the table is currently loading data from the backend
 */
const ProductFabricTable = ({
  data,
  pagination,
  onFetchData,
  hiddenColumns,
  isLoading,
  rowButtonProps
}) => {
  const {
    handleEnableFabric,
    handleDisableFabric
  } = rowButtonProps

  const columns = useMemo(() => tableColumns({
    handleEnableFabric,
    handleDisableFabric
  }), [
    handleEnableFabric,
    handleDisableFabric
  ])

  return (
    <DataTable
      data={ data }
      columns={ columns }
      pagination={ pagination }
      onFetchData={ onFetchData }
      hiddenColumns={ hiddenColumns }
      isLoading={ isLoading }
    />
  )
}

ProductFabricTable.propTypes    = propTypes
ProductFabricTable.defaultProps = defaultProps

export default ProductFabricTable
